var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRejcted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_18",
    "data-name": "Subtraction 18",
    d: "M9.5,19A9.5,9.5,0,0,1,2.783,2.782,9.5,9.5,0,1,1,16.217,16.218,9.437,9.437,0,0,1,9.5,19ZM8.477,12.6v1.5h1.707V12.6ZM9.32,4.75H9.3a1.359,1.359,0,0,0-1.01.41,1.571,1.571,0,0,0-.371,1.2c.086,1.489.2,2.72.371,3.875.163,1.125.229,1.39.93,1.39.241,0,.544-.032.965-.075H10.2q.05-.408.1-.809l.006-.046c.072-.584.14-1.136.2-1.7.022-.2.046-.4.069-.6V8.384c.077-.655.157-1.333.181-2a1.629,1.629,0,0,0-.409-1.224A1.389,1.389,0,0,0,9.32,4.75Z",
    transform: "translate(0.5 0.5)",
    fill: "#0094d9",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejcted);
export default __webpack_public_path__ + "static/media/rejcted.06c1399427329cab263995325c096321.svg";
export { ForwardRef as ReactComponent };